import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Menu from "../components/Menu";
import { refreshAccessToken, logout } from "../actions/user";
import {fetchSystemInfo} from "../actions/systemInfo";

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      logout,
      refreshAccessToken,
      fetchSystemInfo
    },
    dispatch
  );

export default connect(null, mapDispatchToProps)(Menu);
